'use client';

import { useElevationControl } from '@web-store-platforms/providers/elevation';
import { cn } from '@/lib/utils/cn';

interface IConsentOverlayProps {
    onOverlayClick: () => void;
    isTransparent?: boolean;
    title?: string;
}

export function ConsentOverlay({
    onOverlayClick,
    isTransparent = false,
    title,
}: IConsentOverlayProps): React.ReactElement {
    const ambientZIndex = useElevationControl();

    return (
        <div
            className={cn(
                'fixed inset-0',
                isTransparent ? 'bg-transparent cursor-not-allowed' : 'bg-black/40 cursor-pointer'
            )}
            style={{ zIndex: ambientZIndex }}
            onClick={onOverlayClick}
            title={title}
            aria-hidden="true"
            data-testid="consent-overlay"
        />
    );
}
